import React from 'react';
import styled from 'styled-components';
import Pic from 'assets/images/completed.png'


const End = ({ title, subTitle,background }) => {


  return (
    <Container color={background}>
      <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Image src={Pic} />

        <Title>
          {title ? title : "Survey completed"}</Title>
      </div>
      <SubTitle>
        {subTitle ? subTitle :
          "This survey has been successfully submitted."}</SubTitle>

    </Container>

  )
}


export default End

const Title = styled.div`
	font-size: 30px;
  font-weight: bold;
  font-family: 'Red Hat Display', sans-serif;
   line-height:1;
     margin-bottom:10px;

`
const SubTitle = styled.div`
	font-size: 16px;
	line-height: 1.17;
  font-family: 'Red Hat Display', sans-serif;
  margin-bottom:20px;
  text-align:center;

   @media only screen and (min-width:992px){
   margin-bottom:50px;
   font-size: 24px;
  }
`

const Container = styled.div`

  padding:20px;
  width:100%;
  background-color:${props=>props.color};
  color:white;
  height:100vh;
  display:flex;
  padding-top:100px;
  flex-direction:column;
  
 
`

const Image = styled.img`
  width:400px;
  margin-bottom:40px;

  @media(max-width:768px){
    width:100%;
  }
`